import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TelegramIcon, WhatsAppIcon, TeamsIcon } from '../SocialIcons';
import DownloadCounter from '../DownloadCounter';
import { getTelegramUrl, getWhatsAppUrl, getTeamsUrl } from '../../config';
import './RegistrationForm.css';

const RegistrationForm = () => {
  const { t } = useTranslation();

  // const history = useHistory();
  // const { login } = useAuth();
  // const [isLoginMode, setIsLoginMode] = useState(false);
  const [email, setEmail] = useState('');
  // const [password, setPassword] = useState('');
  // const [rememberMe, setRememberMe] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isThankYouOpen, setIsThankYouOpen] = useState(false);
  // const [isRegistering, setIsRegistering] = useState(false);
  // const [isLoggingIn, setIsLoggingIn] = useState(false);
  // const [loginError, setLoginError] = useState('');

  useEffect(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsEmailValid(emailRegex.test(email));
  }, [email]);

  const handleSocialClick = (platform) => {
    if (!isEmailValid) {
      return;
    }

    if (platform === 'telegram') {
      window.open(getTelegramUrl(), '_blank');
    } else if (platform === 'whatsapp') {
      window.open(getWhatsAppUrl(), '_blank');
    } else if (platform === 'teams') {
      window.open(getTeamsUrl(), '_blank');
    }

    setIsThankYouOpen(true);
  };

  /**
   * const handleSocialClick = async (platform) => {
   *   if (!isEmailValid || isRegistering) {
   *     return;
   *   }
   *
   *   setIsRegistering(true);
   *
   *   try {
   *     const response = await fetch(getApiUrl(config.api.endpoints.auth.register), {
   *       method: 'POST',
   *       headers: {
   *         'Content-Type': 'application/json',
   *       },
   *       body: JSON.stringify({
   *         email: email,
   *         platform: platform,
   *       }),
   *     });
   *
   *     if (!response.ok) {
   *       const error = await response.json();
   *       alert(error.message || config.errors.registrationFailed);
   *       setIsRegistering(false);
   *       return;
   *     }
   *
   *     const data = await response.json();
   *     if (platform === 'telegram') {
   *       window.open(getTelegramUrl(), '_blank');
   *     } else if (platform === 'whatsapp') {
   *       window.open(getWhatsAppUrl(), '_blank');
   *     } else if (platform === 'teams') {
   *       window.open(getTeamsUrl(), '_blank');
   *     }
   *
   *     console.log('Регистрация успешна! Ссылка активации:', data.activationLink);
   *     alert('Регистрация успешна! Проверьте консоль сервера для получения ссылки активации.');
   *   } catch (error) {
   *     console.error('Ошибка при регистрации:', error);
   *     alert(config.errors.serverNotRunning);
   *   } finally {
   *     setIsRegistering(false);
   *   }
   * };
   *
   * const handleLogin = async (e) => {
   *   e.preventDefault();
   *   setLoginError('');
   *   setIsLoggingIn(true);
   *
   *   try {
   *     const result = await login(email, password, rememberMe);
   *     
   *     if (result.success) {
   *       history.push('/cabinet');
   *     } else {
   *       setLoginError(result.error || t('landing.form.loginError'));
   *     }
   *   } catch (error) {
   *     console.error('Ошибка при авторизации:', error);
   *     setLoginError(t('landing.form.loginError'));
   *   } finally {
   *     setIsLoggingIn(false);
   *   }
   * };
   */

  return (
    <div className="registration-form-modern">
      <div className="form-header-modern">
        <h2 className="form-title-modern">
          {t('landing.form.title')}
        </h2>
        <p className="form-subtitle-modern">
          {t('landing.form.subtitle')}
        </p>
      </div>

      {/* <div className="form-toggle-container">
        <button
          className={`toggle-option ${!isLoginMode ? 'active' : ''}`}
          onClick={() => setIsLoginMode(false)}
        >
          {t('landing.form.register')}
        </button>
        <button
          className={`toggle-option ${isLoginMode ? 'active' : ''}`}
          onClick={() => setIsLoginMode(true)}
        >
          {t('landing.form.login')}
        </button>
        <div className={`toggle-slider ${isLoginMode ? 'login' : 'register'}`}></div>
      </div> */}

      {
        <div className="form-steps-container">
          <div className="form-step-modern">
            <div className="step-indicator">1</div>
            <div className="step-content-modern">
              <label className="step-label">{t('landing.form.step1')}</label>
              <div className="input-wrapper-modern">
                <input
                  type="email"
                  placeholder={t('landing.form.emailPlaceholder')}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="email-input-modern"
                />
                {email && !isEmailValid && (
                  <div className="input-error-modern">{t('landing.form.emailError')}</div>
                )}
                {isEmailValid && (
                  <div className="input-success-modern">{t('common.verified')}</div>
                )}
              </div>
            </div>
          </div>

          <div className="form-step-modern">
            <div className="step-indicator">2</div>
            <div className="step-content-modern">
              <label className="step-label">{t('landing.form.step2')}</label>
              <div className="social-buttons-modern">
                <button
                  className={`social-btn-modern telegram ${isEmailValid ? 'enabled' : 'disabled'}`}
                  onClick={() => handleSocialClick('telegram')}
                  disabled={!isEmailValid}
                >
                  <span className="social-icon-modern">
                    <TelegramIcon />
                  </span>
                  <span>{t('landing.form.telegram')}</span>
                </button>
                <button
                  className={`social-btn-modern whatsapp ${isEmailValid ? 'enabled' : 'disabled'}`}
                  onClick={() => handleSocialClick('whatsapp')}
                  disabled={!isEmailValid}
                >
                  <span className="social-icon-modern">
                    <WhatsAppIcon />
                  </span>
                  <span>{t('landing.form.whatsapp')}</span>
                </button>
                <button
                  className={`social-btn-modern teams ${isEmailValid ? 'enabled' : 'disabled'}`}
                  onClick={() => handleSocialClick('teams')}
                  disabled={!isEmailValid}
                >
                  <span className="social-icon-modern">
                    <TeamsIcon />
                  </span>
                  <span>{t('landing.form.teams')}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      }

      {/*
        TEMP_MVP_LANDING: полная форма логина была здесь.
        Ниже оставлен оригинальный JSX, полностью закомментированный для будущего возврата.

        ) : (
        <form className="login-form-modern" onSubmit={handleLogin}>
          {loginError && (
            <div className="login-error-message">
              {loginError}
            </div>
          )}
          
          <div className="login-input-group">
            <label className="login-label">{t('landing.form.emailLabel')}</label>
            <div className="input-wrapper-modern">
              <input
                type="email"
                placeholder={t('landing.form.fillField')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="email-input-modern"
                required
                disabled={isLoggingIn}
              />
            </div>
          </div>

          <div className="login-input-group">
            <label className="login-label">{t('landing.form.password')}</label>
            <div className="input-wrapper-modern">
              <input
                type="password"
                placeholder={t('landing.form.fillField')}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="email-input-modern"
                required
                disabled={isLoggingIn}
              />
            </div>
          </div>

          <div className="login-options">
            <label className="remember-me-label">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="remember-me-checkbox"
                disabled={isLoggingIn}
              />
              <span>{t('landing.form.rememberMe')}</span>
            </label>
          </div>

          <button 
            type="submit" 
            className="login-submit-btn"
            disabled={isLoggingIn}
          >
            <span>{isLoggingIn ? t('common.loading') : t('landing.form.loginButton')}</span>
            {!isLoggingIn && (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            )}
          </button>
        </form>
      )*/}

      <DownloadCounter />
      {isThankYouOpen && (
        <div className="thankyou-backdrop">
          <div className="thankyou-modal">
            <h3 className="thankyou-title">Thanks!</h3>
            <p className="thankyou-text">The data has been successfully submitted!</p>
            <button
              type="button"
              className="thankyou-button"
              onClick={() => setIsThankYouOpen(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegistrationForm;

